export default __webpack_public_path__ + "static/media/logo.6f1441d3.svg";